import classNames from 'classnames';
import { OrderMenuSet } from 'earn-ts/build/rust';
import { useTranslation } from 'react-i18next';
import { AiFillGift } from 'react-icons/ai';
import { BsReceipt } from 'react-icons/bs';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAppSelector } from 'src/app/store';

// interface IFooterProps {

// }

const listNav = [
  {
    iconComponent: '../../icons/gift.svg',
    class: 'h-[25px] w-[25px]',
    name: '$EARN',
    defaultPath: '',
    pathNames: [''],
  },
  {
    iconComponent: '../../icons/bill.svg',
    class: 'h-[19px] w-[19px] color-primary',
    name: 'Bill',
    defaultPath: '/order/orderBill',
    pathNames: ['orderBill', 'orderCheckout'],
  },
];

const Footer = () => {
  const { t } = useTranslation(['main']);
  const pName = useLocation().pathname.split('/').reverse()[0];
  const navigate = useNavigate();

  const handleClickIcon = (itemPath: string) => {
    navigate(itemPath);
  };

  const currentTabIndex = listNav.findIndex(item =>
    item.pathNames.includes(pName),
  );

  const { dataSelectedMenus, fullOrder } = useAppSelector(state => state.order);

  const handleGotoBill = () => {
    if (fullOrder) {
      navigate('../orderBill', {
        relative: 'path',
      });
    } else {
      toast.warning(t('please-place-order'));
    }
  };

  const TotalQuantity = (data: Array<OrderMenuSet>) => {
    let total = 0;
    data.forEach(item => {
      total = total + item.quantity;
    });
    return total;
  };

  const totalOrder = TotalQuantity(dataSelectedMenus);

  const handleGotoCheckout = () => {
    if (totalOrder)
      navigate('../orderCheckout', {
        relative: 'path',
      });
  };

  return (
    <div className="border-t-[1.5px] border-solid border-shadow-1 bg-white fixed bottom-0 w-full flex flex-row px-[0px] text-[12px] py-[8px] shadow-[2px_5px_5px_7px_rgba(0,0,0,0.12)] justify-between">
      <div className="w-[50%] flex flex-row font-bold">
        <div className="w-[40%] flex flex-col items-center justify-center text-primary">
          <div className="h-[40px] w-[40px] bg-primary bg-gradient-to-bl from-primary via-primary to-secondary/80 rounded-[50%] flex items-center justify-center">
            <AiFillGift className="cursor-pointer text-[#fff]" fontSize={20} />
          </div>
          EARN
        </div>
        <div className="w-[40%] flex flex-col items-center justify-center">
          <div
            className="h-[40px] w-[40px] bg-shadow-2 rounded-[50%] flex items-center justify-center"
            onClick={handleGotoBill}>
            <BsReceipt className="cursor-pointer" fontSize={18} />
          </div>
          {t('Bill')}
        </div>
      </div>

      <div
        className={classNames(
          'w-[130px] my-2 mx-3 flex items-center justify-center rounded-[20px] cursor-pointer',
          {
            'bg-primary': totalOrder,
            'bg-shadow-1': !totalOrder,
          },
        )}
        onClick={handleGotoCheckout}>
        {/*<div className="flex items-center justify-center">
              <PiCallBell className={`cursor-pointer mr-[15px] ${totalOrder? 'text-[#fff]' : ""}`} fontSize={24}/>
              </div>*/}
        <div
          className={`font-bold ${totalOrder ? 'text-white' : ''} text-[16px]`}>
          {t('place-order')}
        </div>
        {!!totalOrder && (
          <div
            className={classNames(
              'h-[22px] w-[22px] rounded-[50%] absolute text-center opacity-90 font-bold text-[12px] top-[12px] right-[128px] flex items-center justify-center bg-secondary text-black',
            )}>
            {totalOrder}
          </div>
        )}
      </div>
    </div>
    // <div className="font-medium flex items-center fixed bottom-0 left-0 w-full justify-between">
    //   {listNav.map((item, index) => (
    //     <div
    //       className={`flex flex-col justify-center hover:text-[#FFB500] items-center w-full ${index === currentTabIndex && 'text-[#FFB500]'
    //         }`}
    //       onClick={() => handleClickIcon(item.defaultPath)}
    //       key={index}
    //     >
    //        <img src={`${item.iconComponent}`} className={`${item.class}`}/>
    //       <div className="flex font-medium p-1 justify-between text-[12px]">{t(item.name)}</div>
    //     </div>
    //   ))}
    // </div>
  );
};

export default Footer;
